<template>
  <v-app id="inspire">
    <v-content style="font-family:Microsoft JhengHei;">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
                <v-form ref="form" v-model="valid">
            <v-card class="elevation-12">
                    <v-card-title class="red" dark>
                      <h2>
                        <font style="color:white">忘記密碼</font>
                      </h2>
                    </v-card-title>
              <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="10">
                      <v-text-field
                        label="您的帳號"
                        type="text"
                        :rules="nameRules"
                        dense
                        counter
                        maxlength="20"
                        class="font-weight-normal"
                        v-model="account"
                        :error-messages="txtAccountExists"
                        v-on:change="checkAccount"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="10">
                    <h4>請選擇密碼重設的方式</h4>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="10">
                      <v-radio-group
                        v-model="method"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      >
                        <v-radio label="將臨時密碼寄送到我原先設定的e-mail信箱" value="E" dense color="red"></v-radio>
                        <v-radio label="將臨時密碼寄送到我原先設定的行動電話(限通譯人員使用)" value="M" dense color="red"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="10">
                      <v-spacer></v-spacer>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="10">
                      <v-spacer></v-spacer>
                    </v-col>
                  </v-row>
                    <v-row dense>
                    <v-col cols="12" md="10" >
                      <h6>注意：每日只有三次的使用次數</h6>
                    </v-col>
                  </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey lighten-3" style="color:black;" @click="reset();">清除</v-btn>
                <v-btn color="red" style="color:white;" :disabled="(!valid)" class="ma-2" @click="submitObject($event);" >確定</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="loginGo();" >
                  <span class="mr-2" style="color:grey;font-size:12px;">回登入頁</span>
                </v-btn>
              </v-card-actions>
            </v-card>
                </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";


export default {
  components: {
  },
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  watch: {
  },

  data() {
    return {
      valid: true,
      account: null,
      method: null,
      txtAccountExists: "",
      nameRules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      requiredRules: [v => !!v || "此欄位是必填"]
    };
  },
  methods: {
    ...mapActions(["updateUser"]),

    loginGo() {
      var vm = this;
      vm.$router.push({ path: "/Login" });
    },

    reset() {
      this.txtAccountExists = "";
      this.$refs.form.reset();
      //this.$refs.form.validate();
      //this.$refs.form.resetValidation();
    },
    
    checkAccount() {
      var vm = this;
      if (vm.account.length>5)
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/isAccountExist/" + vm.account,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log("response" + JSON.stringify(response.data));
          vm.txtAccountExists="";
          if (!response.data.exist) {
            vm.txtAccountExists = "帳號不存在，請重新設定";
          }
          console.log("isAccountExist : " + response.data.exist);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    },

    showMsg(msg) {
      swal({
        title: "<h5>忘記密碼</h5>",
        html: "<div align='left'>"+ msg +"</div>",
        padding: 40,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonText: "確認",
        showConfirmButton: true
      }).then((result) => {
          if (result) { this.loginGo(); }
        }
      );
    },
    submitObject() {
      event.target.disabled = true;
      setTimeout(function() {
        // event.target.disabled = false;
      }, 5000);
      var vm = this;
      if (this.$refs.form.validate()) {

        var data = JSON.stringify({
          account: vm.account,
          emailOrMobile: vm.method
        });
        console.log("data is " +JSON.stringify(data));

        vm.axios
          .post(vm.idbServerUrl + "idb/forgetPassword", data, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(function(response) {
            console.log("@@@@111 " + JSON.stringify(response));           
            vm.showMsg("請稍待片刻，系統將傳送臨時密碼至您的信箱或行動電話");
          })
          .catch(function(error) {
            console.log("@@@@99 " + error);
            vm.showMsg("已達一日三次的使用限制");
          });
      }

    }
  },
  mounted() {
    this.$refs.form.validate();
  }
};
</script>